function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".isko_icon_video-noise_svg__cls-2{stroke:transparent!important;stroke-miterlimit:10;stroke-width:2px;fill:none}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M11 18l-6-6 6-6v12z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2 9h6v6H2z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "isko_icon_video-noise_svg__cls-2",
  d: "M14 8l8 8M22 8l-8 8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
});

function SvgIskoIconVideoNoise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "isko_icon_video-noise_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+LmNscy0xe3N0cm9rZTpjdXJyZW50Q29sb3I7c3Ryb2tlLW1pdGVybGltaXQ6MTA7c3Ryb2tlLXdpZHRoOjJweDt9LmNscy0ye3N0cm9rZTp0cmFuc3BhcmVudAogICAgICAhaW1wb3J0YW50O3N0cm9rZS1taXRlcmxpbWl0OjEwO3N0cm9rZS13aWR0aDoycHg7fS5jbHMtMiwuY2xzLTN7ZmlsbDpub25lO30KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDx0aXRsZT5NdXRlIHZvbHVtZTwvdGl0bGU+CiAgPHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9IjExIDE4IDUgMTIgMTEgNiAxMSAxOCIvPgogIDxyZWN0IHg9IjIiIHk9IjkiIHdpZHRoPSI2IiBoZWlnaHQ9IjYiLz4KICA8bGluZSBjbGFzcz0iY2xzLTIiIHgxPSIxNCIgeTE9IjgiIHgyPSIyMiIgeTI9IjE2Ii8+CiAgPGxpbmUgY2xhc3M9ImNscy0yIiB4MT0iMjIiIHkxPSI4IiB4Mj0iMTQiIHkyPSIxNiIvPgogIDxyZWN0IGNsYXNzPSJjbHMtMyIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ii8+Cjwvc3ZnPgo=";
export { SvgIskoIconVideoNoise as ReactComponent };